export const isFullStatic = false
export const staticPath = "/home/smiley/3df/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"